import styled from 'styled-components';
import BaseTooltip from '@prisjakt/ui-tooltip';

export const Tooltip = styled(BaseTooltip)``;
export const TooltipTrigger = styled.div`
  position: relative;

  ${Tooltip} {
    transition: visibility 0s 0.1s, opacity 0.1s linear;
    visibility: hidden;
    opacity: 0;
    z-index: 9999;
  }

  :hover ${Tooltip} {
    transition: visibility 0s, opacity 0.2s linear;
    visibility: visible;
    opacity: 1;
  }
`;
